// @generated by protobuf-ts 2.9.0 with parameter long_type_number,generate_dependencies
// @generated from protobuf file "permissions.proto" (syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { Permissions } from "./permissions";
import type { UpdatePermissionAccountRequest } from "./permissions";
import type { CreatePermissionAccountRequest } from "./permissions";
import type { DeletePermissionRoomRequest } from "./permissions";
import type { DeletePermissionDeskRequest } from "./permissions";
import type { DeletePermissionAccountRequest } from "./permissions";
import type { MigrationResponse } from "./permissions";
import type { CheckPermissionResponse } from "./permissions";
import type { CheckPermissionRequest } from "./permissions";
import type { GetCustomerPermissionsResponse } from "./permissions";
import type { GetCustomerPermissionsRequest } from "./permissions";
import type { ListPermissionGroupCandidatesResponse } from "./permissions";
import type { ListPermissionGroupCandidatesRequest } from "./permissions";
import type { ListPermissionGroupMembersResponse } from "./permissions";
import type { ListPermissionGroupMembersRequest } from "./permissions";
import type { GetPermissionGroupRequest } from "./permissions";
import type { DeletePermissionGroupRequest } from "./permissions";
import type { UpdatePermissionGroupRequest } from "./permissions";
import type { CreatePermissionGroupRequest } from "./permissions";
import type { ListPermissionGroupsResponse } from "./permissions";
import type { ListPermissionGroupsRequest } from "./permissions";
import type { PermissionGroupDetailedResponse } from "./permissions";
import type { CreateDefaultPermissionGroupRequest } from "./permissions";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { Empty } from "./google/protobuf/empty";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service Permissions
 */
export interface IPermissionsClient {
    /**
     * @generated from protobuf rpc: Heartbeat(google.protobuf.Empty) returns (google.protobuf.Empty);
     */
    heartbeat(input: Empty, options?: RpcOptions): UnaryCall<Empty, Empty>;
    /**
     * @generated from protobuf rpc: CreateDefaultPermissionGroup(CreateDefaultPermissionGroupRequest) returns (PermissionGroupDetailedResponse);
     */
    createDefaultPermissionGroup(input: CreateDefaultPermissionGroupRequest, options?: RpcOptions): UnaryCall<CreateDefaultPermissionGroupRequest, PermissionGroupDetailedResponse>;
    /**
     * @generated from protobuf rpc: ListPermissionGroups(ListPermissionGroupsRequest) returns (ListPermissionGroupsResponse);
     */
    listPermissionGroups(input: ListPermissionGroupsRequest, options?: RpcOptions): UnaryCall<ListPermissionGroupsRequest, ListPermissionGroupsResponse>;
    /**
     * @generated from protobuf rpc: CreatePermissionGroup(CreatePermissionGroupRequest) returns (PermissionGroupDetailedResponse);
     */
    createPermissionGroup(input: CreatePermissionGroupRequest, options?: RpcOptions): UnaryCall<CreatePermissionGroupRequest, PermissionGroupDetailedResponse>;
    /**
     * @generated from protobuf rpc: UpdatePermissionGroup(UpdatePermissionGroupRequest) returns (PermissionGroupDetailedResponse);
     */
    updatePermissionGroup(input: UpdatePermissionGroupRequest, options?: RpcOptions): UnaryCall<UpdatePermissionGroupRequest, PermissionGroupDetailedResponse>;
    /**
     * @generated from protobuf rpc: DeletePermissionGroup(DeletePermissionGroupRequest) returns (google.protobuf.Empty);
     */
    deletePermissionGroup(input: DeletePermissionGroupRequest, options?: RpcOptions): UnaryCall<DeletePermissionGroupRequest, Empty>;
    /**
     * @generated from protobuf rpc: GetPermissionGroup(GetPermissionGroupRequest) returns (PermissionGroupDetailedResponse);
     */
    getPermissionGroup(input: GetPermissionGroupRequest, options?: RpcOptions): UnaryCall<GetPermissionGroupRequest, PermissionGroupDetailedResponse>;
    /**
     * @generated from protobuf rpc: ListPermissionGroupMembers(ListPermissionGroupMembersRequest) returns (ListPermissionGroupMembersResponse);
     */
    listPermissionGroupMembers(input: ListPermissionGroupMembersRequest, options?: RpcOptions): UnaryCall<ListPermissionGroupMembersRequest, ListPermissionGroupMembersResponse>;
    /**
     * @generated from protobuf rpc: ListPermissionGroupCandidates(ListPermissionGroupCandidatesRequest) returns (ListPermissionGroupCandidatesResponse);
     */
    listPermissionGroupCandidates(input: ListPermissionGroupCandidatesRequest, options?: RpcOptions): UnaryCall<ListPermissionGroupCandidatesRequest, ListPermissionGroupCandidatesResponse>;
    /**
     * @generated from protobuf rpc: GetCustomerPermissions(GetCustomerPermissionsRequest) returns (GetCustomerPermissionsResponse);
     */
    getCustomerPermissions(input: GetCustomerPermissionsRequest, options?: RpcOptions): UnaryCall<GetCustomerPermissionsRequest, GetCustomerPermissionsResponse>;
    /**
     * @generated from protobuf rpc: CheckPermission(CheckPermissionRequest) returns (CheckPermissionResponse);
     */
    checkPermission(input: CheckPermissionRequest, options?: RpcOptions): UnaryCall<CheckPermissionRequest, CheckPermissionResponse>;
    /**
     * @generated from protobuf rpc: Migration(google.protobuf.Empty) returns (MigrationResponse);
     */
    migration(input: Empty, options?: RpcOptions): UnaryCall<Empty, MigrationResponse>;
    /**
     * @generated from protobuf rpc: Sync(google.protobuf.Empty) returns (google.protobuf.Empty);
     */
    sync(input: Empty, options?: RpcOptions): UnaryCall<Empty, Empty>;
    /**
     * @generated from protobuf rpc: DeleteAccount(DeletePermissionAccountRequest) returns (google.protobuf.Empty);
     */
    deleteAccount(input: DeletePermissionAccountRequest, options?: RpcOptions): UnaryCall<DeletePermissionAccountRequest, Empty>;
    /**
     * @generated from protobuf rpc: DeleteDesk(DeletePermissionDeskRequest) returns (google.protobuf.Empty);
     */
    deleteDesk(input: DeletePermissionDeskRequest, options?: RpcOptions): UnaryCall<DeletePermissionDeskRequest, Empty>;
    /**
     * @generated from protobuf rpc: DeleteRoom(DeletePermissionRoomRequest) returns (google.protobuf.Empty);
     */
    deleteRoom(input: DeletePermissionRoomRequest, options?: RpcOptions): UnaryCall<DeletePermissionRoomRequest, Empty>;
    /**
     * @generated from protobuf rpc: CreatePermissionAccount(CreatePermissionAccountRequest) returns (google.protobuf.Empty);
     */
    createPermissionAccount(input: CreatePermissionAccountRequest, options?: RpcOptions): UnaryCall<CreatePermissionAccountRequest, Empty>;
    /**
     * @generated from protobuf rpc: UpdatePermissionAccount(UpdatePermissionAccountRequest) returns (google.protobuf.Empty);
     */
    updatePermissionAccount(input: UpdatePermissionAccountRequest, options?: RpcOptions): UnaryCall<UpdatePermissionAccountRequest, Empty>;
}
/**
 * @generated from protobuf service Permissions
 */
export class PermissionsClient implements IPermissionsClient, ServiceInfo {
    typeName = Permissions.typeName;
    methods = Permissions.methods;
    options = Permissions.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Heartbeat(google.protobuf.Empty) returns (google.protobuf.Empty);
     */
    heartbeat(input: Empty, options?: RpcOptions): UnaryCall<Empty, Empty> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, Empty>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateDefaultPermissionGroup(CreateDefaultPermissionGroupRequest) returns (PermissionGroupDetailedResponse);
     */
    createDefaultPermissionGroup(input: CreateDefaultPermissionGroupRequest, options?: RpcOptions): UnaryCall<CreateDefaultPermissionGroupRequest, PermissionGroupDetailedResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateDefaultPermissionGroupRequest, PermissionGroupDetailedResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListPermissionGroups(ListPermissionGroupsRequest) returns (ListPermissionGroupsResponse);
     */
    listPermissionGroups(input: ListPermissionGroupsRequest, options?: RpcOptions): UnaryCall<ListPermissionGroupsRequest, ListPermissionGroupsResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListPermissionGroupsRequest, ListPermissionGroupsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreatePermissionGroup(CreatePermissionGroupRequest) returns (PermissionGroupDetailedResponse);
     */
    createPermissionGroup(input: CreatePermissionGroupRequest, options?: RpcOptions): UnaryCall<CreatePermissionGroupRequest, PermissionGroupDetailedResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreatePermissionGroupRequest, PermissionGroupDetailedResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdatePermissionGroup(UpdatePermissionGroupRequest) returns (PermissionGroupDetailedResponse);
     */
    updatePermissionGroup(input: UpdatePermissionGroupRequest, options?: RpcOptions): UnaryCall<UpdatePermissionGroupRequest, PermissionGroupDetailedResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdatePermissionGroupRequest, PermissionGroupDetailedResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeletePermissionGroup(DeletePermissionGroupRequest) returns (google.protobuf.Empty);
     */
    deletePermissionGroup(input: DeletePermissionGroupRequest, options?: RpcOptions): UnaryCall<DeletePermissionGroupRequest, Empty> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeletePermissionGroupRequest, Empty>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetPermissionGroup(GetPermissionGroupRequest) returns (PermissionGroupDetailedResponse);
     */
    getPermissionGroup(input: GetPermissionGroupRequest, options?: RpcOptions): UnaryCall<GetPermissionGroupRequest, PermissionGroupDetailedResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetPermissionGroupRequest, PermissionGroupDetailedResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListPermissionGroupMembers(ListPermissionGroupMembersRequest) returns (ListPermissionGroupMembersResponse);
     */
    listPermissionGroupMembers(input: ListPermissionGroupMembersRequest, options?: RpcOptions): UnaryCall<ListPermissionGroupMembersRequest, ListPermissionGroupMembersResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListPermissionGroupMembersRequest, ListPermissionGroupMembersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListPermissionGroupCandidates(ListPermissionGroupCandidatesRequest) returns (ListPermissionGroupCandidatesResponse);
     */
    listPermissionGroupCandidates(input: ListPermissionGroupCandidatesRequest, options?: RpcOptions): UnaryCall<ListPermissionGroupCandidatesRequest, ListPermissionGroupCandidatesResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListPermissionGroupCandidatesRequest, ListPermissionGroupCandidatesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetCustomerPermissions(GetCustomerPermissionsRequest) returns (GetCustomerPermissionsResponse);
     */
    getCustomerPermissions(input: GetCustomerPermissionsRequest, options?: RpcOptions): UnaryCall<GetCustomerPermissionsRequest, GetCustomerPermissionsResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetCustomerPermissionsRequest, GetCustomerPermissionsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CheckPermission(CheckPermissionRequest) returns (CheckPermissionResponse);
     */
    checkPermission(input: CheckPermissionRequest, options?: RpcOptions): UnaryCall<CheckPermissionRequest, CheckPermissionResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<CheckPermissionRequest, CheckPermissionResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Migration(google.protobuf.Empty) returns (MigrationResponse);
     */
    migration(input: Empty, options?: RpcOptions): UnaryCall<Empty, MigrationResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, MigrationResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Sync(google.protobuf.Empty) returns (google.protobuf.Empty);
     */
    sync(input: Empty, options?: RpcOptions): UnaryCall<Empty, Empty> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, Empty>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteAccount(DeletePermissionAccountRequest) returns (google.protobuf.Empty);
     */
    deleteAccount(input: DeletePermissionAccountRequest, options?: RpcOptions): UnaryCall<DeletePermissionAccountRequest, Empty> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeletePermissionAccountRequest, Empty>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteDesk(DeletePermissionDeskRequest) returns (google.protobuf.Empty);
     */
    deleteDesk(input: DeletePermissionDeskRequest, options?: RpcOptions): UnaryCall<DeletePermissionDeskRequest, Empty> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeletePermissionDeskRequest, Empty>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteRoom(DeletePermissionRoomRequest) returns (google.protobuf.Empty);
     */
    deleteRoom(input: DeletePermissionRoomRequest, options?: RpcOptions): UnaryCall<DeletePermissionRoomRequest, Empty> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeletePermissionRoomRequest, Empty>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreatePermissionAccount(CreatePermissionAccountRequest) returns (google.protobuf.Empty);
     */
    createPermissionAccount(input: CreatePermissionAccountRequest, options?: RpcOptions): UnaryCall<CreatePermissionAccountRequest, Empty> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreatePermissionAccountRequest, Empty>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdatePermissionAccount(UpdatePermissionAccountRequest) returns (google.protobuf.Empty);
     */
    updatePermissionAccount(input: UpdatePermissionAccountRequest, options?: RpcOptions): UnaryCall<UpdatePermissionAccountRequest, Empty> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdatePermissionAccountRequest, Empty>("unary", this._transport, method, opt, input);
    }
}
